export default __webpack_public_path__ + "static/px11-cf90d9170505fb3b0b1867a875b45f61.jpg";